import React, { useEffect, useState } from "react";
import api from "../../Utils/api";
import Spinner from "../Spinner";
import ExportDropdown from "../Calendar/ExportDropdown";

function transformUsers(users) {
  //   console.log(users.length);

  return users.map((user) => ({
    preferred: user.preferredName || `${user.firstName} ${user.lastName}`,
    full: `${user.firstName} ${user.lastName}`,
    first: user.firstName,
    last: user.lastName,
    location: user.locations?.primaryLocation?.name?.trim() || "Unknown",
    status: user.allowed ? "Employed" : "Inactive",
    mobile: user.phone || "null",
    email: user.email || "null",
    emergencyName: user.emergencyContactName || "null",
    emergencyPhone: user.emergencyContactNumber || "null",
  }));
}

export default function EmployeeTable() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getUsers = async () => {
    setIsLoading(true);
    const res = await api.get("/user");
    setIsLoading(false);

    if (res.data.success) {
      setUsers(res.data.users.filter((u) => !u.archive));
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const employees = transformUsers(users);

  return (
    <div className="px-8 bg-white">
      {isLoading && <Spinner />}
      <h2 className="text-lg font-semibold mb-4">Emergency Contacts</h2>
      <ExportDropdown data={employees} />
      <div className=" max-h-[80vh] mt-2 overflow-y-auto">
        <table className="min-w-full border border-gray-200 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-gray-50 text-gray-700">
              <th className="px-2 py-1 border-b text-left">Preferred Name</th>
              <th className="px-2 py-1 border-b text-left">Full Name</th>
              <th className="px-2 py-1 border-b text-left">First Name</th>
              <th className="px-2 py-1 border-b text-left">Last Name</th>
              <th className="px-2 py-1 border-b text-left">Primary Location</th>
              <th className="px-2 py-1 border-b text-left">Status</th>
              <th className="px-2 py-1 border-b text-left">
                Employee Contact Mobile
              </th>
              <th className="px-2 py-1 border-b text-left">
                Employee Contact Email
              </th>
              <th className="px-2 py-1 border-b text-left">
                Emergency Contact Name
              </th>
              <th className="px-2 py-1 border-b text-left">
                Emergency Contact Phone
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp, idx) => (
              <tr key={idx} className="border-b">
                <td className="px-2 py-1">{emp.preferred}</td>
                <td className="px-2 py-1">{emp.full}</td>
                <td className="px-2 py-1">{emp.first}</td>
                <td className="px-2 py-1">{emp.last}</td>
                <td className="px-2 py-1">{emp.location}</td>
                <td className="px-2 py-1">{emp.status}</td>
                <td className="px-2 py-1">{emp.mobile}</td>
                <td className="px-2 py-1">{emp.email}</td>
                <td className="px-2 py-1">{emp.emergencyName}</td>
                <td className="px-2 py-1">{emp.emergencyPhone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
